/* Sculpt Method – shared buy button (direct to checkout)
   Any <form data-sm-atc> is submitted via AJAX: the cart is cleared, the
   selected variant is added, and the customer goes straight to checkout.
   Errors (e.g. sold out) show in the nearest [data-sm-error] inside
   [data-sm-pdp] or [data-sm-atc-root]. */
(() => {
  if (window.smCartInit) return;
  window.smCartInit = true;

  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const setLoading = (btn, on) => {
    if (!btn) return;
    btn.classList.toggle('loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.querySelector('.loading__spinner')?.classList.toggle('hidden', !on);
    if (on) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
  };

  const readError = async (res) => {
    try {
      const data = await res.json();
      return data.description || data.message || '';
    } catch (e) {
      return '';
    }
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-sm-atc]');
    if (!form) return;
    e.preventDefault();

    const root = form.closest('[data-sm-pdp], [data-sm-atc-root]');
    const btn = form.querySelector('button[name="add"]');
    const errorBox = root?.querySelector('[data-sm-error]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    setLoading(btn, true);

    try {
      /* Start from an empty cart so checkout only contains this order */
      await fetch(routeRoot + 'cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });

      const res = await fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!res.ok) {
        const msg = await readError(res);
        throw new Error(msg || 'This item could not be added. Try again.');
      }

      window.location.href = routeRoot + 'checkout';
    } catch (err) {
      if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
      setLoading(btn, false);
    }
  });

  /* Coming back from checkout with the browser back button: reset spinners */
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('form[data-sm-atc] button[name="add"]').forEach((btn) => setLoading(btn, false));
  });
})();